import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import PText from 'components/Primatives/PText';

const DisplayWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
`

const CodeWrapper = styled.div`
    @import url('https://fonts.googleapis.com/css?family=Roboto+Mono:500');
    font-family: 'Roboto Mono', monospace;
    font-size: 20px;
    font-weight: 500;
    margin-left: 5px;
    color: #4daeb9;
    border: 1px solid grey;
    border-radius: 10px;
    width: 14vw;
    text-align:center;
    padding: 6px;
`

const ActivationCodeDisplay = ({code}) => {
    return(
        <DisplayWrapper>
            <PText> Activation code: </PText>
            <CodeWrapper>{code}</CodeWrapper>
        </DisplayWrapper>
    )
}

ActivationCodeDisplay.propTypes = {
    /** 8 characters long code to be displayed */
    code: PropTypes.string.isRequired
}

ActivationCodeDisplay.defaultProps = {
    code: '00000000'
}

export default ActivationCodeDisplay;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/ActivationCodeDisplay.jsx